import { render, staticRenderFns } from "./newLink.vue?vue&type=template&id=3815760d&scoped=true&"
import script from "./newLink.vue?vue&type=script&lang=js&"
export * from "./newLink.vue?vue&type=script&lang=js&"
import style0 from "./newLink.vue?vue&type=style&index=0&id=3815760d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3815760d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3815760d')) {
      api.createRecord('3815760d', component.options)
    } else {
      api.reload('3815760d', component.options)
    }
    module.hot.accept("./newLink.vue?vue&type=template&id=3815760d&scoped=true&", function () {
      api.rerender('3815760d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/SOP/components/newLink.vue"
export default component.exports